import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Button } from "../atoms/button";
import { Label } from "../atoms/label";
import { Link } from "react-router-dom";
import { SoloTimeSet } from "../molecules/soloTimeSet";
import { useHistory } from 'react-router-dom';
import { connect, useStore } from "react-redux";
import { GolfStartTimeSelectFooterContainer } from './golfStartTimeSelectFooterContainer';
import common from "../../resources/js/common/common"
import { getSoloAvailability, versionGetApi } from '../../const';
import { apiKeyCheck } from '../../const';
import "../../resources/css/soloReserve/soloStartTime.css";
import commonUtil from '../../common/commonUtil';
import { Loading } from "../molecules/loading";
import { useRtoaster } from '../../hooks/useRtoaster';

const StartTimeSelectContainer = (props) => {
    const store = useStore();
    const {
        golfSoloTeetime,
        setGolfSoloTeetime,
        golfSoloSearchData,
        setGolfSoloSearchData,
    } = props;

    const [planInfo, setPlanInfo] = useState([]);
    const [courseList, setCourseList] = useState([]);

    const history = useHistory();

    const [courseName, setCourseName] = useState("");
    const [planDate, setPlanDate] = useState("");
    const [planName, setPlanName] = useState("");
    const [price, setPrice] = useState("");
    const [resPlanInfo, setResPlanInfo] = useState({});
    const [loadingFlg,setLoadingFlg]= useState(false);

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": golfSoloSearchData.golfCourseId,
        "riyodat": golfSoloSearchData.playDate,
        "keiyakuno": golfSoloSearchData.contractNo,
        "packcd": golfSoloSearchData.planId,
        "packnam": golfSoloSearchData.planName,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        console.log("詳細読み込み開始");
        setLoadingFlg(true);
        common.doPost(versionGetApi, {}, afterVerCheck);

        // プレイヤー入力値の初期化
        setGolfSoloTeetime({})
        // プラン情報の設定(空き情報取得リクエスト)
        const req = {
            playDate: golfSoloSearchData.playDate,
            golfCourseId: golfSoloSearchData.golfCourseId,
            membershipAuthID: golfSoloSearchData.memberShipAuth,
            planId: golfSoloSearchData.planId,
            kaiinKind: golfSoloSearchData.kaiinKind
        }
        common.doPost(getSoloAvailability, req, afterGetPlanInfo);
        common.scrollWindowTop();
        console.log("詳細読み込み終了");
    }, []);

    const afterGetPlanInfo = (res) => {
        console.log("詳細APIレスポンス処理スタート");
        const data = res.data;
        if (data.resultCode == 0) {
            const newPlanInfo = {
                golfCourseId: data.golfCourseId,
                golfCourseName: data.golfCourseName,
                planId: data.planId,
                planName: data.planName,
                minPrice: data.minPrice
            }
            convertResPlanInfo(data);
            setPlanInfo(newPlanInfo)
            setCourseName("ゴルフ場：" + data.golfCourseName);
            setPlanDate("プレー日：" + commonUtil.getStringFromDateJpnGolf(golfSoloSearchData.playDate));
            setPlanName("プラン名：" + data.planName);
            setPrice("料金：￥"+ data.minPrice.toLocaleString() + "～");
            setCourseList(data.courseList);
        }
        setLoadingFlg(false);
        console.log("詳細APIレスポンス処理エンド");
    }

    /**
     * APIレスポンス値からプラン情報を抜き出しstateに格納
     * @param {*空き状況取得APIレスポンス値} resData 
     */
    const convertResPlanInfo = (resData) => {
        const planObj = {
            isCaddy:resData.isCaddy,
            cartType:resData.cartType,
            isLunch:resData.isLunch,
            is2Sum:resData.is2Sum,
            content:resData.content,
            planRemark:resData.planRemark,
            price:resData.price,
            golfTax:resData.golfTax,
            tax:resData.tax,
            priceTotal:resData.priceTotal,
            otherfee:resData.otherfee,
            otherfeeMemo:resData.otherfeeMemo,
            extraFee2Bag:resData.extraFee2Bag,
            extraFee3Bag:resData.extraFee3Bag,
            reservationQualification:resData.reservationQualification,
            point:resData.point
        }
        setResPlanInfo(planObj);
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = () => {
        history.push("/reserve/golf/soloSearch");
    };

    const onClickReserve = (courseInfo) => {
        const newGolfSoloTeetime = {
            teetimeId: courseInfo.teetimeId,
            startTime: courseInfo.teetime,
            courseId: courseInfo.courseId,
            courseName: courseInfo.courseName,
            golfCourseId: planInfo.golfCourseId,
            planId: planInfo.planId,
            planName: planInfo.planName,
            golfCourseName:planInfo.golfCourseName,
            planInfo:resPlanInfo,
        }
        setGolfSoloTeetime(newGolfSoloTeetime);
        history.push("/reserve/golf/soloUserInput");
    };

    return (
        <div>
            {loadingFlg ?
                <Loading 
                    width={50}
                    height={50}
                    type={"spin"}
                    color={"white"}
                /> : null
            }
            <div className='soloStartTime_breadCrumb'>
                <Link to={"/reserve/top"} className='soloStartTime_pan' >HOME</Link>
                <Label label=">" className='soloStartTime_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloSearch"} className='soloStartTime_pan' >ゴルフ一人予約</Link>
                <Label label=">" className='soloStartTime_breadCrumbArrow' />
                <Label label="スタート時間" className='soloStartTime_pan' />
            </div>
            <div className='soloStartTime_base'>
                <div className='soloStartTime_box'>
                    <Label label={planDate} className='soloStartTime_title2' />
                    <Label label={courseName} className='soloStartTime_title2' />
                    <Label label={planName} className='soloStartTime_title2' />
                    <Label label={price} className='soloStartTime_price' />
                    <br />
                    <SoloTimeSet
                        courseList={courseList}
                        onClickReserve={onClickReserve}
                    />
                    <div className='soloStartTime_btnArea'>
                        <Button buttonText="戻 る" className='soloStartTime_backBtn' onClick={onClickBack} />
                    </div>
                    <div className='soloStartTime_topBtnArea'>
                        <Link className='soloStartTime_linkTop' to="/reserve/golf/soloSearch" >ゴルフ一人予約TOPへ戻る</Link>
                    </div>
                </div>
            </div>
            <GolfStartTimeSelectFooterContainer />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        golfSoloSearchData: state.golfSoloSearchData,
        golfSoloTeetime: state.golfSoloTeetime,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setGolfSoloTeetime: (item) => {
            dispatch({ type: "GOLF_SOLO_TEETIME", payload: { golfSoloTeetime: item } })
        },
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
        addInputPlayer: (item) => {
            dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(StartTimeSelectContainer);
